import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/** Branding of the alliance a player-hub magic-link token belongs to. */
export function usePlayerAlliance(token: string | undefined) {
  const q = useQuery({
    queryKey: ['player-alliance', token],
    queryFn: () => api.getPlayerAllianceBranding(token!),
    enabled: !!token,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
  return q.data ?? null;
}
